import React from "react";
import "./Companies.css";

const Companies = () => {
  return (
    <section className="c-wrapper">
      <div className="c-container innerWidth flexCenter paddings">
        <img src="./versace.png" alt="Hello" />
        <img src="./zara.png" alt="Hello" />
        <img src="./gucci.png" alt="Hello" />
        <img src="./prada.png" alt="Hello" />
        <img src="./calvin.png" alt="Hello" />
      </div>
    </section>
  );
};
export default Companies;
